export const userHeaders = {
    USER_NAME : 'Username',
    EMPLOYEE_NAME : 'Employee Name',
    ROLE : 'Role',
    MOBILE_NUMBER : 'Mobile Number',
    EMAIL_ID : 'Email Id'
}